import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiDraftSection(rfpExcerpt: string, sectionLabel: string, guidance: string, onStream: (chunk: string) => void): Promise<void> {
  const system = `You are an elite RFP proposal writer. Draft a polished "${sectionLabel}" section based on the RFP excerpt below. Follow this guidance: ${guidance}. Mirror buyer language. Be concrete. Avoid vague claims. Output the section body only — no headings.`;
  try {
    await streamGroq({
      messages: [{ role: 'system', content: system }, { role: 'user', content: `RFP excerpt:\n${rfpExcerpt.slice(0, 6000)}` }],
      temperature: 0.4, onStream,
    });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) { onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ to add your free key. Requirement extraction + scoring work fully without it.'); return; }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
